import { connect } from 'react-redux';
import CopyLinkButton from 'common/components/copy_link_button';
import { getProject } from 'project/ducks/project';
import { getProjectUrl } from 'project/utils';
import { getSubcategorySlug } from 'common/ducks/categories';

const mapStateToProps = (state) => {
  const project = getProject(state) || {};
  const subcategory = getSubcategorySlug(state.categories, project.sub_category);
  /* @TODO: grab shortened URL for this project */
  const projectUrl = getProjectUrl(project, subcategory);

  return {
    link: `${window.location.origin}${projectUrl}`
  };
};

export default connect(mapStateToProps)(CopyLinkButton);



// WEBPACK FOOTER //
// ./project/containers/copy_link_button.js